import styled from 'styled-components'
import { injectModifiers } from 'ui/themes/utils'
import modifiers from 'ui/themes/modifiers'

const Span = styled.span`  
  ${({ theme }) => injectModifiers(modifiers(theme))}
`

export default Span
